<script setup>
import { useI18n } from 'vue-i18n';
import BaseSettingsHeader from '../../components/BaseSettingsHeader.vue';

const { t } = useI18n();
</script>

<template>
  <BaseSettingsHeader
    :title="t('GENERAL_SETTINGS.TITLE')"
    :description="t('ORGANIZED_SETTINGS.ACCOUNT_DESCRIPTION')"
  />
</template>
